var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LineChart',{attrs:{"height":300,"chartdata":_vm.chartdata,"max":this.max}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }